/**
 * Population Trends + Red List Categories — scroll-in and view-by reveal.
 *
 * Donut fans from 270°; stacked bars expand from the inline-start.
 * View-by (Species / Habitats / clear) plays exit then enter. Flyway-only
 * changes keep in-place morphs. Ease from `@/motion/tokens` (`easeStandard`).
 */

import { durations } from '@/motion/tokens';

export const stateChartReveal = {
  /** IntersectionObserver root margin for scroll-into-view. */
  inViewMargin: '0px',
  /**
   * Start the reveal when this fraction of the plate is visible
   * (mirrors Red List Index).
   */
  inViewThreshold: 0.5,
  /** Play the first entrance once per mount. */
  inViewOnce: true,
  /** Per-segment / per-row expand or fan duration (seconds). ~⅓ slower than `durations.slow`. */
  segmentSeconds: durations.slow * (4 / 3),
  /** Delay between consecutive segments / rows (seconds). */
  staggerSeconds: 0.08,
  /** Centre stack / row-label fade duration (seconds). */
  labelFadeSeconds: durations.base * (4 / 3),
  /** Delay before centre text fade begins on enter (seconds). */
  centreFadeDelaySeconds: 0.16,
} as const;

export type StateChartRevealConfig = typeof stateChartReveal;

/** Reveal lifecycle driven by `useChartReveal`. */
export type ChartRevealPhase = 'hidden' | 'enter' | 'shown' | 'exit';
